// extracted by mini-css-extract-plugin
module.exports = {"profileMessageWrapper":"ProfileMessage_profileMessageWrapper__G_n_L","btnNote":"ProfileMessage_btnNote__ppMaE","message":"ProfileMessage_message__xCISd"};